module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\r\n<div class="droitsdel-tooltip">\r\n  <span class="filtres-content">\r\n		<label for="filtres">'+
((__t=(i18n.t("droitsdel.filtres") + ":"))==null?'':__t)+
'</label>\r\n		<span class="filtres"></span>\r\n  <br/>\r\n  </span>\r\n  <span class="profil-content">\r\n		<label for="profil">'+
((__t=(i18n.t("droitsdel.profil") + ":"))==null?'':__t)+
'</label>\r\n		<span class="profil"></span>\r\n  <br/>\r\n  </span>\r\n  <span class="actions-content">\r\n		<label for="actions">'+
((__t=(i18n.t("droitsdel.actions") + ":"))==null?'':__t)+
'</label>\r\n		<span class="actions"></span>\r\n  </span>\r\n</div>\r\n';
}
return __p;
};
